/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const FAQ = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$customOrderSelectColor: $('#js-custom-order-select-color'),
	$colorOptions: $('.single-product__colors'),
	$customOrderSelectPreservation: $('.custom-order-preservation'),
	$customOrderSelectCountry: $('#billing_country'),

	/** @description Initialize */
	init: function() {
		if (!window.location.pathname.includes('/faq')) {
			return;
		}
		this.appendCustomOrderColors();
		this.handleSelectChange();
		$('.custom-order-preservation').on('change', function() {
			FAQ.appendCustomOrderColors();
		});
	},

	// Append custom order color option
	appendCustomOrderColors: function() {
		let preservationType = $('.custom-order-preservation').val() || 'laminating';
		if (preservationType.toLowerCase() === 'laminating' || preservationType.toLowerCase() === 'framing') {
			let colorSelect = $('#js-custom-order-select-color').parent().parent().find('label');
			let colorLabelText = preservationType.toLowerCase() === 'laminating' ? 'Select edge color' : 'Select frame color';
			colorSelect.text(colorLabelText);
			$('#js-custom-order-select-color').prop('disabled', true);
			$.ajax({
				url: window.fwsLocalized.ajaxUrl, // Ensure this is correctly defined in your WordPress setup
				method: 'POST',
				data: {
					action: 'cf7_get_colors_ajax'
				},
				success: function(response) {
					if (response.success) {
						const colors = preservationType.toLowerCase() === 'laminating' ? response.data.laminating : response.data.framing;
						FAQ.updateColorOptions(colors);
					}
				},
				complete: function() {
					// Re-enable the select field after the AJAX is complete
					$('#js-custom-order-select-color').prop('disabled', false);
					$('#js-custom-order-select-color').parent().parent().find('.contact-us__form-wrap-label').removeClass('is-moved');
				}
			});
		} else {
			FAQ.$customOrderSelectColor.empty();
			FAQ.appendOption(FAQ.$customOrderSelectColor, '', '', '', false); // Placeholder option

			FAQ.$colorOptions.children('.single-product__color').each(function() {
				if ($(this).hasClass('js-single-product__color--spec')) {
					FAQ.appendOption(FAQ.$customOrderSelectColor, 'Choose for me', 'Choose for me', '', true);
					return;
				}
				const colorHex = $(this).css('background-color');
				const colorName = $(this).children('.single-product__color-title').text();
				FAQ.appendOption(FAQ.$customOrderSelectColor, colorName, colorName, colorHex, false);
			});
		}
	},

	updateColorOptions: function(colors) {
		FAQ.$customOrderSelectColor.empty();
		FAQ.appendOption(FAQ.$customOrderSelectColor, '', '', '', false);
		FAQ.appendOption(FAQ.$customOrderSelectColor, 'Choose for me', 'Choose for me', '', true);
		colors.forEach(color => {
			FAQ.appendOption(FAQ.$customOrderSelectColor, color.title, color.title, color.rgb, false);
		});
	},

	// Append new option to select
	appendOption: function(selector, value, text, color, special) {
		// If special option render different class
		if (special) {
			selector.append(`<option value="${value}"><span class="color-dot-spec">${text}</span></option>`);
		} else {
			selector.append(`<option value="${value}"><span class="color-dot" style="background-color: ${color};">${text}</span></option>`);
		}
	},

	//Clearing error message from input/select field
	clearFormErrors: function(e) {
		const errorSpan = $(e.target).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip');
		const errorSelect = $(e.target).closest('.wpcf7-form-control-wrap').find('.wpcf7-select');
		if (errorSpan.length > 0) {
			errorSpan.remove();
		}
		if (errorSelect.length > 0) {
			errorSelect.removeClass('wpcf7-not-valid');
		}
	},

	handleSelectChange: function() {
		FAQ.$customOrderSelectColor.on('change', function(e) {
			FAQ.clearFormErrors(e);
		});
		FAQ.$customOrderSelectPreservation.on('change', function(e) {
			FAQ.clearFormErrors(e);
		});
		FAQ.$customOrderSelectCountry.on('change', function(e) {
			FAQ.clearFormErrors(e);
		});
	},
};

export default FAQ;